import View from './View';

export { default as View, getSettingsTechnicalInfoStyles } from './View';

export default View;
